import { motion, useInView } from "framer-motion"
import { graphql, Link } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import { Autoplay, Navigation } from "swiper"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from "swiper/react"

const Instagram = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const handleNextClick = selector => {
    const swiper = document.querySelector(selector).swiper
    swiper.slideNext()
  }
  const handlePrevClick = selector => {
    const swiper = document.querySelector(selector).swiper
    swiper.slidePrev()
  }

  const [data, setData] = useState([])

  useEffect(() => {
    try {
      const fetchData = async () => {
        fetch(
          `${process.env.GATSBY_INSTAGRAM_URL}` + `${module.instagramToken}`
        )
          .then(response => response.json())
          .then(result => {
            if (result.data) {
              const filteredData = result.data.filter(item => item.media_type !== "VIDEO");
              setData(filteredData);
            } else {
              console.log(result.error.message)
            }
          })
      }
      fetchData()
    } catch (error) {
      console.log(error)
    }
  }, [])

  if (module.hideSection === "no") {
    return (
      <section
        className={`instagram${
          module.extraClass ? ` ${module.extraClass}` : ""
        }`}
        id={module.extraId}
      >
        <div className="container-fluid">
          <div className="bgBaptiste pt-100 lgscreen:pt-50 text-center">
            <motion.div
              initial="hidden"
              animate={isInView || hasPlayed ? "show" : "hidden"}
              variants={sectionShow}
            >
              <motion.div
                ref={ref}
                initial="hidden"
                animate={isInView || hasPlayed ? "show" : "hidden"}
                variants={sectionShow}
              >
                <div className="w-full max-w-[960px] px-20 text-center mx-auto">
                  {module?.headingLink !== null ? (
                    <Link to={module.headingLink.url} target={module.headingLink.target} className="text_black">
                      <motion.h3 variants={animFade} className="text_black">
                        {module.headingLink.title}
                      </motion.h3>
                    </Link>
                  ): 
                    <motion.h3 variants={animFade} className="text_black">
                        {module.heading}
                    </motion.h3>}
                  {module?.description && (
                    <motion.div
                      variants={animFade}
                      className="content pt-5 text_black"
                    >
                      {parse(module.description)}
                    </motion.div>
                  )}
                </div>
                <motion.div
                  variants={animFade}
                  className="mt-50 lgscreen:mt-25 px-80 lgscreen:px-40 relative"
                >
                  <Swiper
                    spaceBetween={30}
                    loop={false}
                    slidesPerView={"4"}
                    speed={1000}
                    pagination={{
                      clickable: false,
                    }}
                    breakpoints={{
                      0: {
                        slidesPerView: 1,
                      },
                      641: {
                        slidesPerView: 3,
                      },
                      1024: {
                        slidesPerView: 4,
                      },
                    }}
                    modules={[Autoplay, Navigation]}
                  >
                    {data.map((item, i) => (
                      <SwiperSlide key={i}>
                        <div className="img relative">
                          <Link to={item.permalink} target="_blank">
                            <img src={item.media_url} alt={`Instagram ${i}`} />
                          </Link>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>

                  <div className="swiper-arrow arrow-big flex gap-x-5">
                    <button
                      className="absolute left-55 top-50per translate-y-minus_50 z-9 transition-all duration-300 outline-none"
                      onClick={() => handlePrevClick(".bgBaptiste .swiper")}
                    >
                      <img
                        src="../../images/micro-slider-arrow.svg"
                        width={42}
                        height={42}
                        loading="lazy"
                        alt="Arrow"
                      />
                    </button>
                    <button
                      className="absolute right-55 top-50per translate-y-minus_50 z-9 transition-all duration-300 outline-none"
                      onClick={() => handleNextClick(".bgBaptiste .swiper")}
                    >
                      <img
                        src="../../images/micro-slider-arrow.svg"
                        width={42}
                        height={42}
                        className="scale-x-[-1]"
                        loading="lazy"
                        alt="Arrow"
                      />
                    </button>
                  </div>
                </motion.div>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>
    )
  }
  return null
}

export default Instagram
export const EatDrinkInstagramFragment = graphql`
  fragment EatDrinkInstagramFragment on WpEatDrink_Restaurantcontent_RestaurantContent_Instagram {
    extraId
    extraClass
    hideSection
    heading
    headingLink {
      target
      title
      url
    }
    description
    instagramToken
  }
`
